import inpostGeowidgetHtml from './inpostGeowidget.modal.html';
import downloadOfferHtml from './downloadOffer.modal.html';
import downloadOfferController from './downloadOffer.controller';
import './downloadOffer.modal.scss';

class CheckoutService {

    constructor($http, $q, $timeout, SnackbarService, translateService, priceTypeService, ModalService) {
        'ngInject';

        this.$http = $http;
        this.$q = $q;
        this.$timeout = $timeout;
        this.SnackbarService = SnackbarService;
        this.translate = translateService;
        this.priceType = priceTypeService;
        this.ModalService = ModalService;

        this.currentTimestamp = new Date().getTime();

        this.isDev = false;
        this.aLogged = false;

        this.loaded = false;
        this.loading = false;
        this.showAllErrors = false;

        this.loadingInvoiceData = false;
        this.loadedInvoiceDataError = null;
        this.loadingCartItems = false;

        // Step 1
        this.items = [];
        this.summary = null;
        this.payments = null;
        this.paymentGroups = null;
        this.shipments = null
        this.payment = '';
        this.conversion = {};
        this.orderId = null;
        this.userEmail = null;
        this.step = 1;
        this.userLogged = false;
        this.userHasDiscount = false;
        this.userCategoryClub = false;
        this.downloadOfferModal = null;

        // Step 2
        this.userDataForm = null;
        this.data = {
            comments: '',
            invoice_comments: '',
            newsletter: false,
            terms: false,
            shipmentAddressId: null,
            invoiceAddressId: null,
            shipmentAddress: {
                companyName: '',
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                address: '',
                city: '',
                zipCode: '',
                country: ''
            },
            invoiceAddress: {
                companyName: '',
                firstName: '',
                lastName: '',
                taxNumber: '',
                noTaxNumber: 0,
                icoNumber: '',
                address: '',
                city: '',
                zipCode: '',
                country: '',
                invoice: '0'
            },
            isDropshippingAddress: false,
            dropshippingAddress: {
                companyName: '',
                firstName: '',
                lastName: '',
                address: '',
                city: '',
                zipCode: '',
                country: ''
            }
        };
        this.shippingAddressAutofilled = false;
        this.billieStatus = false;
        this.billie = {};
        this.returnToCartUrl = '/';
        this.tabSelected = 0;

        // Step 3
        this.confirmation = {
            payment: null,
            shipment: null,
            invoiceAddress: null,
            shipmentAddress: null,
            isDropshippingAddress: false,
            dropshippingAddress: null
        }

        this.addresses = {
            shipment: [],
            invoice: []
        };

        this.piggyBank = null;
        this.taxIdOmit = false;
        this.inpostGeowidgetModal = null;

        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        this.dataValidations = {
            // adres do wysyłki
            shipmentAddressFirstName: () => this.data.shipmentAddress.firstName != '',
            shipmentAddressLastName: () => this.data.shipmentAddress.lastName != '',
            shipmentAddressEmail: () => emailRegex.test(String(this.data.shipmentAddress.email).toLowerCase()),
            shipmentAddressPhone: () => this.data.shipmentAddress.phone.length >= 9,
            shipmentAddressAddress: () => (this.summary && !this.summary.shipping_data) || this.data.shipmentAddress.address != '',
            shipmentAddressCity: () => (this.summary && !this.summary.shipping_data) || this.data.shipmentAddress.city != '',
            shipmentAddressZipCode: () => (this.summary && !this.summary.shipping_data) || this.data.shipmentAddress.zipCode != '',

            // faktura VAT na firmę lub płatność wymaga podania NIP
            invoiceAddressTaxNumber: () => {
                if ((this.data.invoice && this.data.invoiceAddress.taxNumber == '') || (this.summary && this.summary.payment_nip_required && this.data.invoiceAddress.taxNumber == '')) {
                    return false;
                }

                return true;
            },
        };

        this.loggedDataValidations = {
            // adres do wysyłki
            invoiceAddressId: () => this.data.invoiceAddressId,
            paymentId: () => this.summary.payment_id
        };
    }

    get countries() {
        return window.countries;
    }

    get shopId() {
        return window.shopId;
    }

    get shopShipmentCountries() {
        return window.shopShipmentCountries;
    }

    get shopPaymentCountries() {
        return window.shopPaymentCountries;
    }

    get shopCountry() {
        return window.shopCountry;
    }

    get paymentsFiltered() {
        if (!this.payments) {
            return null;
        }

        let invoice, country;

        if (!this.userLogged) {
            invoice = this.data.invoiceAddress.invoice === '1'
            country = this.data.invoiceAddress.country;
        } else {
            const invoiceAddress = this.getAddressById(this.data.invoiceAddressId);
            if (!invoiceAddress) {
                return this.payments;
            }

            invoice = !!invoiceAddress.company || !!invoiceAddress.tax_id;
            country = invoiceAddress.country;
        }

        let filteredPayments = this.payments;

        if (invoice) {
            filteredPayments = filteredPayments.filter(payment => payment.module !== 'klarna');
        }

        if (!invoice || country !== 'DE') {
            filteredPayments = filteredPayments.filter(payment => payment.module !== 'billie');
        }

        return filteredPayments;
    }

    load() {
        if (this.data.shipmentAddress.country === '') {
            this.data.shipmentAddress.country = this.shopCountry;
        }

        if (this.data.invoiceAddress.country === '') {
            this.data.invoiceAddress.country = this.shopCountry;
        }

        const deferred = this.$q.defer();
        this.loading = true;
        this.loadingCartItems = true;

        this.$http.get('/ajax/checkout/get-cart-content').then(
            (response) => {
                const data = response.data.data;

                for (const product of data.products) {
                    product.savedQuantity = product.quantity;
                    if(product.productionFile){
                        product.productionFile = atob(product.productionFile);
                    }
                }

                this.isDev = data.is_dev;
                this.aLogged = data.a_logged;

                this.userLogged = data.user_logged;
                this.userLoggedEmail = data.user_logged_email;
                this.userLoggedPhone = data.user_logged_phone;
                this.userHasDiscount = data.user_has_discount;
                this.userCategoryClub = data.user_category_club;
                this.userCategoryClubShowPrompt = data.user_category_club_show_prompt;
                this.items = data.products;
                this.summary = data.summary;
                this.billie = data.billie;
                this.piggyBank = data.piggy_bank;
                this.piggyBank.entered_gros_value = this.piggyBank.entered_gros_value.replace(',', '.');
                this.piggyBank.entered_net_value = this.piggyBank.entered_net_value.replace(',', '.');
                if (parseFloat(this.piggyBank.entered_gros_value.replace(',', '.')) === 0) {
                    this.piggyBank.entered_gros_value = 0;
                }
                if (parseFloat(this.piggyBank.entered_net_value.replace(',', '.')) === 0) {
                    this.piggyBank.entered_net_value = 0;
                }
                this.returnToConfiguratorUrl = data.return_to_configurator_url;
                this.data.comments = data.comments;
                this.data.invoice_comments = data.invoice_comments;

                if (typeof data.invoice_address === 'string') {
                    this.data.invoiceAddressId = parseInt(data.invoice_address);
                } else if (data.invoice_address && Object.keys(data.invoice_address).length > 0) {
                    this.data.invoiceAddress = data.invoice_address;
                } else if (typeof data.invoice_address === 'number') {
                    this.data.invoiceAddressId = data.invoice_address;
                }

                if (typeof data.shipment_address === 'string') {
                    this.data.shipmentAddressId = parseInt(data.shipment_address);
                } else if (data.shipment_address && Object.keys(data.shipment_address).length > 0) {
                    this.shippingAddressAutofilled = true;
                    this.data.shipmentAddress = data.shipment_address;
                } else if (typeof data.shipment_address === 'number') {
                    this.data.shipmentAddressId = data.shipment_address;
                }

                if (data.invoice_address && typeof data.invoice_address.phone === 'string') {
                    data.invoice_address.phone = parseInt(data.invoice_address.phone);
                }

                if (data.shipment_address && typeof data.shipment_address.phone === 'string') {
                    data.shipment_address.phone = parseInt(data.shipment_address.phone);
                }

                let isDropshippingAddress = false;
                let dropshippingAddress = {
                    companyName: '',
                    firstName: '',
                    lastName: '',
                    address: '',
                    city: '',
                    zipCode: '',
                    country: ''
                };
                if (data.dropshipping_address !== null) {
                    isDropshippingAddress = true;
                    dropshippingAddress = data.dropshipping_address;
                }

                this.data.isDropshippingAddress = isDropshippingAddress;
                this.data.dropshippingAddress = dropshippingAddress;

                this.confirmation = {
                    payment: data.payment,
                    shipment: data.shipment,
                    invoiceAddress: data.invoice_address,
                    shipmentAddress: data.shipment_address,
                    isDropshippingAddress: isDropshippingAddress,
                    dropshippingAddress: dropshippingAddress
                }

                this.loaded = true;
                this.loading = false;
                this.loadingCartItems = false;

                deferred.resolve({
                    items: this.items,
                    summary: this.summary
                });
            },
            (response) => {
                this.loading = false;
                this.loadingCartItems = false;
                this.loaded = true;

                if (response.status == 404) {
                    this.items = [];
                    this.summary = null;

                    deferred.resolve({
                        items: this.items,
                        summary: null
                    });

                    return;
                }

                this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);

                deferred.reject(this.translate.t('cart.errors.unexpected'));
            }
        );

        return deferred.promise;
    }

    loadPayments() {
        const deferred = this.$q.defer();
        this.loading = true;

        this.$http.get('/ajax/checkout/get-payments').then(
            (response) => {
                this.loading = false;
                const data = response.data.data;

                this.payments = data.payments;
                this.paymentGroups = data.paymentGroups;

                deferred.resolve({
                    payments: this.payments,
                    paymentGroups: this.paymentGroups
                });
            },
            (response) => {
                this.loading = false;

                if (response.status != 404)
                    this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);

                deferred.reject(this.translate.t('cart.errors.unexpected'));
            }
        );

        return deferred.promise;
    }

    loadShipments() {
        if (!this.summary) return;

        const deferred = this.$q.defer();
        this.loading = true;

        this.$http.post(
            '/ajax/checkout/get-shipments',
            {
                country: this.summary.country
            }
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.data.message && response.data.data.message.type != 'success') {

                    const message = response.data.message.content;

                    this.SnackbarService.add(message, 'error', true, 3000);

                    this.shipments = null;

                    deferred.reject(message);

                    return;
                }

                const data = response.data.data;

                this.shipments = data.shipments.map(shipment => {
                    shipment.options = {};
                    shipment.id = parseInt(shipment.id);

                    return shipment;
                });

                deferred.resolve({
                    shipments: this.shipments
                });
            },
            (response) => {
                this.loading = false;

                if (response.status != 404)
                    this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);

                deferred.reject(this.translate.t('cart.errors.unexpected'));
            }
        );

        return deferred.promise;
    }

    loadAddresses() {
        const deferred = this.$q.defer();
        this.loading = true;

        let count = 0;

        this.$http.get('/ajax/checkout/get-shipment-addresses').then(
            (response) => {
                count++;

                this.addresses.shipment = response.data.data.addresses.filter(
                    address => address.country in this.shopShipmentCountries
                );

                if (count < 2) return;

                this.loading = false;
                deferred.resolve(this.addresses);
            },
            (response) => {
                this.loading = false;

                this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);

                deferred.reject(this.translate.t('cart.errors.unexpected'));
            }
        );

        this.$http.get('/ajax/checkout/get-invoice-addresses').then(
            (response) => {
                count++;

                this.addresses.invoice = response.data.data.addresses.filter(
                    address => address.country in this.shopPaymentCountries
                );

                if (count < 2) return;

                this.loading = false;
                deferred.resolve(this.addresses);
            },
            (response) => {
                this.loading = false;
                this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);
                deferred.reject(this.translate.t('cart.errors.unexpected'));
            }
        );

        return deferred.promise;
    }

    setPiggyBankValue(value) {
        const deferred = this.$q.defer();
        this.loading = true;

        if (typeof (value) === 'string') {
            value = parseFloat(value.replace(',', '.'));
        }

        this.$http.post(
            '/ajax/checkout/set-piggy-bank-value',
            {
                value: value,
                priceType: this.priceType.priceType
            }
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.message && response.data.message.type != 'success') {
                    const message = response.data.message.content;
                    this.SnackbarService.add(message, 'error', true, 3000);
                    deferred.reject(message);
                    return;
                } else if(response.data.message && response.data.message.content) {
                    const message = response.data.message;
                    this.SnackbarService.add(message.content, message.type, true, 2000);
                }

                const data = response.data.data;
                this.summary = data.summary;
                this.load();

                deferred.resolve(response.data);
            },
            (response) => {
                this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);

                deferred.reject(this.translate.t('cart.errors.unexpected'));
            }
        );

        return deferred.promise;
    }

    changeQuantity(item) {
        if (!this.loaded) return;

        this.downloadOfferModal = null;

        const deferred = this.$q.defer();
        this.loading = true;

        this.$http.post(
            '/ajax/checkout/change-product-quantity',
            {
                productId: item.product_id,
                variantId: item.variant_id || null,
                quantity: item.quantity
            }
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.data.message && response.data.data.message.type != 'success') {

                    const message = response.data.message.content;

                    this.SnackbarService.add(message, 'error', true, 3000);

                    for (const item of this.items) {
                        item.quantity = item.savedQuantity;
                    }

                    deferred.reject(message);

                    return;
                }

                const data = response.data.data;

                this.items = data.products;

                for (const product of this.items) {
                    product.savedQuantity = product.quantity;
                    if (product.productionFile) {
                        product.productionFile = atob(product.productionFile);
                    }
                }

                this.summary = data.summary;

                deferred.resolve({
                    items: this.items,
                    summary: this.summary
                });
            },
            (response) => {
                for (const item of this.items) {
                    item.quantity = item.savedQuantity;
                }

                this.loading = false;

                this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);

                deferred.reject(this.translate.t('cart.errors.unexpected'));
            }
        );

        return deferred.promise;
    }

    removeItem(item) {
        if (!this.loaded) {
            return;
        }

        this.downloadOfferModal = null;

        const deferred = this.$q.defer();
        this.loading = true;

        const saveCopy = this.items;

        this.items = this.items.filter(checkoutItem => item != checkoutItem);

        this.$http.post(
            '/ajax/checkout/delete-product',
            {
                productId: item.product_id,
                variantId: item.variant_id || null
            }
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.message && response.data.message.type != 'success') {

                    const message = response.data.message.content;

                    this.SnackbarService.add(message, 'error', true, 3000);

                    this.items = saveCopy;

                    deferred.reject(message);

                    return;
                }

                const message = response.data.message.content;

                const data = response.data.data;

                for (const product of data.products) {
                    product.savedQuantity = product.quantity;
                    if(product.productionFile){
                        product.productionFile = atob(product.productionFile);
                    }
                }

                this.items = data.products;
                this.summary = data.summary;

                deferred.resolve({
                    items: this.items,
                    summary: this.summary
                });

                this.SnackbarService.add(message, 'success', true, 3000);
            },
            (response) => {
                this.items = saveCopy;
                this.loading = false;

                this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);

                deferred.reject(this.translate.t('cart.errors.unexpected'));
            }
        );

        return deferred.promise;
    }

    saveUploadedPrintFile(item) {
        if (!this.loaded) return;

        const deferred = this.$q.defer();
        this.loading = true;

        this.$http.post(
            '/ajax/checkout/save-upload-print-file',
            {
                productId: item.product_id,
                variantId: item.variant_id || null,
                printFileId: item.printFileId
            }
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.data.message && response.data.data.message.type !== 'success') {

                    const message = response.data.message.content;

                    this.SnackbarService.add(message, 'error', true, 3000);

                    item.printFileId = null;

                    deferred.reject(message);

                    return;
                }

                const data = response.data.data;

                this.items = data.products;

                for (const product of this.items) {
                    product.savedQuantity = product.quantity;
                    if (product.productionFile) {
                        product.productionFile = atob(product.productionFile);
                    }
                }

                this.summary = data.summary;

                deferred.resolve({
                    items: this.items,
                    summary: this.summary
                });
            },
            (response) => {
                item.printFileId = null;

                this.loading = false;

                this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);

                deferred.reject(this.translate.t('cart.errors.unexpected'));
            }
        );

        return deferred.promise;
    }

    addDiscountCode(code) {
        const deferred = this.$q.defer();
        this.loading = true;

        this.$http.post(
            '/ajax/checkout/discount-code',
            {code}
        ).then(
            (response) => {
                this.loading = false;

                if (response.data.message && response.data.message.type != 'success') {

                    const message = response.data.message.content;

                    this.SnackbarService.add(message, 'error', true, 3000);

                    deferred.reject(message);

                    return;
                }

                const data = response.data.data;
                this.summary = data.summary;
                this.load();

                deferred.resolve();
            },
            (response) => {
                this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);

                deferred.reject(this.translate.t('cart.errors.unexpected'));
            }
        );

        return deferred.promise;
    }

    removeDiscountCode() {
        const deferred = this.$q.defer();
        this.loading = true;

        this.$http.post(
            '/ajax/checkout/discount-code',
            {
                code: ''
            }
        ).then(
            (response) => {
                this.loading = false;

                if (!response.data.data) {
                    this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);

                    deferred.reject(this.translate.t('cart.errors.unexpected'));

                    return;
                }

                const data = response.data.data;
                this.summary = data.summary;
                this.load();

                deferred.resolve();
            },
            (response) => {
                this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);

                deferred.reject(this.translate.t('cart.errors.unexpected'));
            }
        );

        return deferred.promise;
    }

    setPayment(payment) {
        this.summary.payment_id = payment.id;

        return true;
    }

    setShipment(shipment, options = null) {
        this.downloadOfferModal = null;

        const deferred = this.$q.defer();
        this.loading = true;

        const previousShipmentId = this.summary.shipment_id;

        this.summary.shipment_id = shipment.id;
        if (options) {
            this.summary.shipment_options = options;
        }

        if (shipment.transport_type === 'paczkomaty' && this.summary.shipment_options === null) {
            this.loading = false;

            this.summary.shipment_id = previousShipmentId

            this.initInpostGeowidget(shipment)

            deferred.resolve({
                summary: this.summary
            });

            return deferred.promise;
        }

        this.$http.post(
            '/ajax/checkout/set-shipment',
            {
                shipmentId: this.summary.shipment_id,
                options: this.summary.shipment_options
            }
        ).then(
            (response) => {
                this.loading = false;

                if (!response.data) {
                    this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);

                    deferred.reject(this.translate.t('cart.errors.unexpected'));

                    return;
                }

                const data = response.data.data;

                this.summary = data.summary;
                this.confirmation.shipment = shipment;

                deferred.resolve({
                    summary: this.summary
                });
            },
            (response) => {
                this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);

                deferred.reject(this.translate.t('cart.errors.unexpected'));
            }
        );

        return deferred.promise;
    }

    initInpostGeowidget(shipment) {
        let _this = this;

        if(!_this.inpostGeowidgetModal) {
            this.ModalService.showModal({
                template: inpostGeowidgetHtml,
                controller: class {
                    constructor($scope, close) {
                        'ngInject';

                        this.token = null;
                        this.tokens = {
                            production: 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJzQlpXVzFNZzVlQnpDYU1XU3JvTlBjRWFveFpXcW9Ua2FuZVB3X291LWxvIn0.eyJleHAiOjIwNDA2MjIzNDIsImlhdCI6MTcyNTI2MjM0MiwianRpIjoiZTM3ZDU5OWEtYTkwMS00NDI5LWExZmUtNzdiNzI5OTc5OTFjIiwiaXNzIjoiaHR0cHM6Ly9sb2dpbi5pbnBvc3QucGwvYXV0aC9yZWFsbXMvZXh0ZXJuYWwiLCJzdWIiOiJmOjEyNDc1MDUxLTFjMDMtNGU1OS1iYTBjLTJiNDU2OTVlZjUzNTpxckxmSDAwRDZWYkp6OUNPTTUwcWRrd3Q1cWd5VC1zY2JwNUdRTk5oYm13IiwidHlwIjoiQmVhcmVyIiwiYXpwIjoic2hpcHgiLCJzZXNzaW9uX3N0YXRlIjoiNzJiYzYxZWMtNzFjNS00MDk5LTgzNzUtMDdhMzEyYWQ5NWM2Iiwic2NvcGUiOiJvcGVuaWQgYXBpOmFwaXBvaW50cyIsInNpZCI6IjcyYmM2MWVjLTcxYzUtNDA5OS04Mzc1LTA3YTMxMmFkOTVjNiIsImFsbG93ZWRfcmVmZXJyZXJzIjoiKi5wbGFzdGljZXhwcmVzcy5wbCxwbGFzdGljZXhwcmVzcy5wbCIsInV1aWQiOiIyMzAxMmY5OS01NGViLTQ3ODQtOTBiMi0wMmQ0ZGZiZWYxNWQifQ.XcOjZ0_TzqNQrhd23FrRU8yS7nfw0CqwhRLGH9zYSNkGXWK47XKvN1eT8fFfztn86kptSwhceaMQkSPy0zy3D9yx8cCuA2K4qTQaaE3-mV2RkyebWtwniicBLRDI0_cn_57v6VMXbXMMXX34T9AN24ENh0LVsK1FqZwR2c4mxRJ8p7NliazUsEuAKsGwHdctm15fwG9RCvnEONgJHbNysjphNGxY73BMbvTMKgAQ89p7YcgKYBXqcQJBNHi4Ri5uTp3Jl6TsqG-tfXF3-ijdsjIVVRKZM0ZCzqlwBQwLwgrH5dnq1qH8JhBjljMKv_0_CX9GVoeY1MBn09SiE4iNQw',
                            sandbox: 'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJkVzROZW9TeXk0OHpCOHg4emdZX2t5dFNiWHY3blZ0eFVGVFpzWV9TUFA4In0.eyJleHAiOjIwMzk1MjQ2NjYsImlhdCI6MTcyNDE2NDY2NiwianRpIjoiNGE1ZDZjYWQtZDhhMi00MWUzLThlY2YtZGU1MTdjMDU2MzE4IiwiaXNzIjoiaHR0cHM6Ly9zYW5kYm94LWxvZ2luLmlucG9zdC5wbC9hdXRoL3JlYWxtcy9leHRlcm5hbCIsInN1YiI6ImY6N2ZiZjQxYmEtYTEzZC00MGQzLTk1ZjYtOThhMmIxYmFlNjdiOjJtdF8yM25xa0pvb3JqRDBvT296ZXE0MHpKX3dlNEJGVXBlcFhGWFVfaEkiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJzaGlweCIsInNlc3Npb25fc3RhdGUiOiI4ZGJkZjMxMC1mMTY2LTQ1ODMtYjg1Yi03NWEwMjM1MzUyYTIiLCJzY29wZSI6Im9wZW5pZCBhcGk6YXBpcG9pbnRzIiwic2lkIjoiOGRiZGYzMTAtZjE2Ni00NTgzLWI4NWItNzVhMDIzNTM1MmEyIiwiYWxsb3dlZF9yZWZlcnJlcnMiOiIqLmNvbnRyYS5tYXEucGwsY29udHJhLm1hcS5wbCIsInV1aWQiOiI4ZTM3NzNkMy00NDhlLTQxMmMtODJiMS0zODI1ZjI1ZmNhY2IifQ.gpVoWI2P58HTBkp9SWKzbAaxa5QKqpFCocjLBkkG8IAJvHr_oHObQcZOCnOe4SEn9IXvNUim76BidJ13CRKb7PY5ee_OoPzYXwGlpqYiC92yOW0tPoDIMLJ2K7h_AD7KI7vKJkN2caV9iXUDmlghUAjOzrOuEcPpKdf_vOL8AwJgf1BvhHvciMi5j8OTFyYtMJitUSUIp-AMoFF3d_OFAGBq7rwbpnHjpKFnYX4E0_ROBezxGldfzvSyv1l9R9IwlnJoo6WoHrGx2jir7y6jk2c99QwGGd2XpIwHp0LSYAAFevGSlgnp4TGsB8FFXHxybTyBYIF448s4MWbe0w8sLg'
                        };
                        this.closeCallback = close;
                        this.init();
                    }

                    init() {
                        if (!_this.isDev) {
                            this.token = this.tokens.production;

                            const geoScript = document.createElement('script');
                            geoScript.type = 'text/javascript';
                            geoScript.src = 'https://geowidget.inpost.pl/inpost-geowidget.js';
                            document.getElementsByTagName('head')[0].appendChild(geoScript);
    
                            const geoCss = document.createElement('link');
                            geoScript.rel = 'stylesheet';
                            geoScript.href = 'https://geowidget.inpost.pl/inpost-geowidget.css';
                            document.getElementsByTagName('head')[0].appendChild(geoCss);
                        } else {
                            this.token = this.tokens.sandbox;

                            const geoScript = document.createElement('script');
                            geoScript.type = 'text/javascript';
                            geoScript.src = 'https://sandbox-easy-geowidget-sdk.easypack24.net/inpost-geowidget.js';
                            document.getElementsByTagName('head')[0].appendChild(geoScript);
    
                            const geoCss = document.createElement('link');
                            geoScript.rel = 'stylesheet';
                            geoScript.href = 'https://sandbox-easy-geowidget-sdk.easypack24.net/inpost-geowidget.css';
                            document.getElementsByTagName('head')[0].appendChild(geoCss);
                        }

                        document.addEventListener('onPaczkomatyTargetPointSelect', (event) => {
                            _this.inpostGeowidgetModal.element.modal('hide');
                        });
                    }

                    cancel() {
                        _this.inpostGeowidgetModal.element.modal('hide');
                    }
                },
                controllerAs: '$ctrl',
                preClose: (modal) => {
                    modal.element.modal('hide');
                }
            }).then(modal => {
                _this.inpostGeowidgetModal = modal;
                modal.element[0].classList.add('inpost-modal');
                modal.element.modal({
                    backdrop: 'static',
                    keyboard: false
                })

                modal.close.then(result => {
                    _this.setPaczkomatyTargetPoint(shipment, result);
                });
            });

            document.addEventListener('onPaczkomatyTargetPointSelect', (event) => {
                this.setPaczkomatyTargetPoint(shipment, event.detail);
            });
        } else {
            _this.inpostGeowidgetModal.element.modal('show');
        }
    }

    setPaczkomatyTargetPoint(shipment, point) {
        this.setShipment(shipment, point);
    }

    setUserDataForm(userDataForm) {
        this.userDataForm = userDataForm;
    }

    get shipmentAddress() {
        return this.userLogged ? this.transformAddress(this.getAddressById(this.data.shipmentAddressId)) : this.data.shipmentAddress;
    }

    get invoiceAddress() {
        return this.userLogged ? this.transformAddress(this.getAddressById(this.data.invoiceAddressId)) : this.data.invoiceAddress;
    }

    payWithBillie() {
        const deferred = this.$q.defer();
        const billieConfigData = {
            'session_id': this.billie.session_id,
            'merchant_name': this.billie.merchant_name
        }

        let orderItems = [];

        this.items.forEach(item => {
            item.price_gros = Math.round(item.price_gros * 100) / 100;
            orderItems.push({
                'external_id': item.product_code,
                'title': item.name,
                'quantity': item.quantity,
                'amount': {
                    'gross': item.price_gros,
                    'net': item.price_net,
                    'tax': Math.round((item.price_gros - item.price_net) * 100) / 100
                }
            });
        });

        const amountGross = Math.round(this.summary.gros_amount_to_pay * 100) / 100;
        const amountTax = Math.round(this.summary.value_of_tax_with_shipment_with_discount * 100) / 100;
        const amountNet = Math.round((amountGross - amountTax) * 100) / 100;

        const billieOrderData = {
            'amount': {
                'gross': amountGross,
                'net': amountNet,
                'tax': amountTax
            },
            'duration': 30,
            'delivery_address': {
                'street': this.shipmentAddress.address,
                'house_number': '',
                'city': this.shipmentAddress.city,
                'postal_code': this.shipmentAddress.zipCode,
                'country': this.shipmentAddress.country
            },
            'debtor_company': {
                'name': this.invoiceAddress.companyName,
                'address_street': this.invoiceAddress.address,
                'address_house_number': '',
                'address_city': this.invoiceAddress.city,
                'address_postal_code': this.invoiceAddress.zipCode,
                'address_country': this.invoiceAddress.country
            },
            'debtor_person': {
                'salutation': 'm',
                'first_name': this.invoiceAddress.firstName,
                'last_name': this.invoiceAddress.lastName,
                'phone_number': this.billie.phone ? this.billie.phone : this.invoiceAddress.phone,
                'email': this.billie.email ? this.billie.email : this.invoiceAddress.email
            },
            'line_items': orderItems
        }

        console.log('Billie', billieConfigData, billieOrderData);

        BillieCheckoutWidget.mount({
            billie_config_data: billieConfigData,
            billie_order_data: billieOrderData,
        }).then(response => {
            if (response.state === 'authorized' || response.state === 'pre_waiting') {
                console.log('Billie: OK', response);
                this.billieApproved = true;
                deferred.resolve(response);
            } else {
                this.SnackbarService.add(this.translate.t('checkout.billiePayment.cannotBeProcessed'), 'error', true, 3000);
                this.billieApproved = false;
                console.log('Billie: Odrzucono');
                deferred.reject(response);
            }
        }).catch(err => {
            this.billieApproved = false;
            console.log('Billie: Error', err);
            this.SnackbarService.add(this.translate.t('checkout.billiePayment.cannotBeProcessed'), 'error', true, 3000);
            deferred.reject(err);
        });

        return deferred.promise;
    }

    setAddressesAndPayment() {
        if (!this.stepTwoComplete) {
            return;
        }

        const deferred = this.$q.defer();

        this.loading = true;

        let data = {...this.data, paymentId: this.summary.payment_id};

        this.$http.post(
            '/ajax/checkout/set-addresses-and-payment',
            data
        ).then(
            (response) => {
                console.log('Billie service resp', response);
                if (response.data && response.data.message && response.data.message.type == 'error') {
                    this.loading = false;
                    this.SnackbarService.add(response.data.message.content, 'error', true, 15000);

                    deferred.reject(response.data.message.content);

                    return;
                }

                if (!response.data.data) {
                    this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);

                    deferred.reject(this.translate.t('cart.errors.unexpected'));

                    return;
                }

                if (response.data && response.data.message && response.data.message.type == 'alert') {
                    this.SnackbarService.add(response.data.message.content, 'error', true, 4000);
                    this.$timeout(() => {
                        deferred.resolve();
                    }, 4000);
                } else {
                    deferred.resolve();
                }
            },
            (response) => {
                console.log('Billie service err', response);
                this.loading = false;
                this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);

                deferred.reject(this.translate.t('cart.errors.unexpected'));
            }
        );

        return deferred.promise;
    }

    finalizeOrder() {
        const deferred = this.$q.defer();

        this.loading = true;

        this.$http.post(
            '/ajax/checkout/finalize-order',
            this.data
        ).then(
            (response) => {
                if (response.data && response.data.message && response.data.message.type == 'error') {
                    this.loading = false;
                    this.SnackbarService.add(response.data.message.content, 'error', true, 15000);

                    deferred.reject(response.data.message);

                    return;
                }

                if (!response.data.data) {
                    this.loading = false;
                    this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);

                    deferred.reject(this.translate.t('cart.errors.unexpected'));

                    return;
                }

                const url = response.data.data.url;

                deferred.resolve({url});
            },
            (response) => {
                this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);

                deferred.reject(this.translate.t('cart.errors.unexpected'));
            }
        );

        return deferred.promise;
    }

    setAddressesFromId() {
        this.loadAddresses().then(() => {
            const invoiceAddress = this.addresses.invoice.find(invoiceAddress => invoiceAddress.id === this.data.invoiceAddressId);
            if (invoiceAddress) {
                this.confirmation.invoiceAddress = this.transformAddress(invoiceAddress);
            }

            let shipmentAddress = this.addresses.shipment.find(shipmentAddress => shipmentAddress.id === this.data.shipmentAddressId);
            if (shipmentAddress) {
                this.confirmation.shipmentAddress = this.transformAddress(shipmentAddress);
                return;
            }

            shipmentAddress = this.addresses.invoice.find(invoiceAddress => invoiceAddress.id === this.data.shipmentAddressId);
            if (shipmentAddress) {
                this.confirmation.shipmentAddress = this.transformAddress(shipmentAddress);
            }
        });
    }

    getAddressById(addressId) {
        let invoiceAddress = this.addresses.invoice.find(invoiceAddress => invoiceAddress.id === addressId);
        if (invoiceAddress) {
            return invoiceAddress;
        }

        let shipmentAddress = this.addresses.shipment.find(invoiceAddress => invoiceAddress.id === addressId);
        if (shipmentAddress) {
            return shipmentAddress;
        }

        return null;
    }

    transformAddress(address, toSnakeCase = false) {
        let map = {
            name: 'addressName',
            company: 'companyName',
            first_name: 'firstName',
            last_name: 'lastName',
            address: 'address',
            city: 'city',
            zip: 'zipCode',
            country: 'country',
            tax_id: 'taxNumber',
            ico_id: 'icoNumber',
            no_tax_id: 'noTaxNumber'
        }

        if (toSnakeCase) {
            let newMap = {};
            for (const [prop, value] of Object.entries(map)) {
                newMap[value] = prop;
            }
            map = newMap;
        }

        let transformedAddress = {};

        for (const [prop, value] of Object.entries(address)) {
            if (map[prop]) {
                transformedAddress[map[prop]] = value;
            } else {
                transformedAddress[prop] = value;
            }
        }

        if (!toSnakeCase) {
            return transformedAddress;
        }

        transformedAddress.address = transformedAddress.address;

        return transformedAddress;
    }

    updateUserInvoiceAddress(currentAddress, callback) {
        // Store and set (as current) address then execute a callback function

        const deferred = this.$q.defer();

        if (this.userLogged) {
            // Logged user
            const invoiceAddress = this.transformAddress(this.getAddressById(this.data.invoiceAddressId));

            // Logged user invoice data doesn't match the data provided in the external source
            if (invoiceAddress.city !== currentAddress.city ||
                invoiceAddress.companyName !== currentAddress.companyName ||
                invoiceAddress.country !== currentAddress.country ||
                invoiceAddress.address !== currentAddress.address ||
                invoiceAddress.zipCode !== currentAddress.zipCode
            ) {
                const newAddress = {
                    ...currentAddress,
                    addressName: 'Billie-erstellte Adresse',
                    firstName: invoiceAddress.firstName,
                    invoice: 1,
                    lastName: invoiceAddress.lastName,
                    taxNumber: invoiceAddress.taxNumber,
                    type: invoiceAddress.type,
                    user_id: invoiceAddress.user_id,
                    noTaxNumber: 0
                };

                this.loading = true;
                this.$http.post('/ajax/checkout/add-new-address', newAddress).then(response => {
                    this.loading = false;
                    if (response.data.message) {
                        const message = response.data.message;
                        this.SnackbarService.add(message.content, 'error', true, 3000);
                        deferred.reject();
                        return;
                    }
                    this.data.invoiceAddressId = response.data.data.addressId;
                    callback();
                }, error => {
                    this.loading = false;
                    this.SnackbarService.add(this.translate.t('cart.errors.unexpected'), 'error', true, 3000);
                    deferred.reject();
                });
            } else {
                callback();
            }
        } else {
            // Not logged user
            if (this.data.invoiceAddress.city !== currentAddress.city ||
                this.data.invoiceAddress.companyName !== currentAddress.companyName ||
                this.data.invoiceAddress.country !== currentAddress.country ||
                this.data.invoiceAddress.address !== currentAddress.address ||
                this.data.invoiceAddress.zipCode !== currentAddress.zipCode
            ) {
                this.data.invoiceAddress = {
                    ...this.data.invoiceAddress,
                    ...currentAddress
                }
            }

            callback();
        }

        return deferred.promise;
    }

    normalizeBillieAddress(billieData) {
        // Transform the Billie address to match the application format
        return {
            companyName: billieData.debtor_company.name,
            city: billieData.debtor_company.address_city,
            country: billieData.debtor_company.address_country,
            zipCode: billieData.debtor_company.address_postal_code,
            address: billieData.debtor_company.address_street + ' ' + billieData.debtor_company.address_house_number
        };
    }

    downloadOffer() {
        if (!this.stepOneComplete) {
            return false;
        }

        if (this.downloadOfferModal) {
            this.downloadOfferModal.element.modal('show');
            return true;
        }

        let userLogged = this.userLogged;
        let shipmentId = this.summary.shipment_id;
        let countries = this.shopPaymentCountries;

        this.ModalService.showModal({
            template: downloadOfferHtml,
            controller: downloadOfferController,
            controllerAs: '$ctrl',
            preClose: (modal) => {
                modal.element.modal('hide');
            },
            inputs: {
                userLogged: userLogged,
                shipmentId: shipmentId,
                countries: countries,
                hide: () => {
                    this.downloadOfferModal.element.modal('hide');
                }
            }
        }).then(modal => {
            this.downloadOfferModal = modal;

            this.downloadOfferModal.element.modal('hide');

            this.downloadOfferModal.element.modal({
                backdrop: 'static',
                keyboard: false
            });
        });

        return true;
    }

    /* State validators */

    get stepOneComplete() {
        if (!this.loaded) return false;

        if (this.loading) return false;

        if (!this.summary) return false;

        if (!this.summary.shipment_id) return false;

        if (!this.shipments) return false;

        const shipment = this.shipments.filter(shipment => shipment.id == this.summary.shipment_id)[0];

        if (!shipment) return false;

        if (shipment.transport_type && shipment.transport_type === 'paczkomaty') {
            if (!this.summary.shipment_options) return false;
        }

        return true;
    }

    get stepTwoComplete() {
        return this.summary.payment_id && this.isUserDataFormValid;
    }

    get stepTwoErrorMessage() {
        if (!this.isUserDataFormValid) {
            return '';
        }
        if (!this.summary.payment_id) {
            return this.translate.t('checkout.selectPaymentMethod');
        }
    }

    get isIcoNumberInputDisplayed() {
        return this.data.invoiceAddress.invoice === '1' && this.shopId === 4;
    }

    get isIcoNumberInputRequired() {
        return this.data.invoiceAddress.country === 'CZ';
    }

    get isIcoNumberRequiredInputDisplayed() {
        return this.isIcoNumberInputDisplayed && this.isIcoNumberInputRequired;
    }

    get isIcoNumberNotRequiredInputDisplayed() {
        return this.isIcoNumberInputDisplayed && !this.isIcoNumberInputRequired;
    }

    get isTaxNumberInputDisplayed() {
        return this.data.invoiceAddress.invoice === '1';
    }

    get isTaxNumberRequiredInputDisplayed() {
        return this.isTaxNumberInputDisplayed && this.isTaxNumberRequired;
    }

    get isTaxNumberNotRequiredInputDisplayed() {
        return this.isTaxNumberInputDisplayed && !this.isTaxNumberRequired;
    }

    get isNameRequired() {
        return this.shopId === 2 ||
            this.shopId === 5 ||
            this.data.invoiceAddress.invoice === '0' ||
            this.data.invoiceAddress.invoice === '1' && (
                !this.data.invoiceAddress.companyName ||
                this.data.invoiceAddress.companyName && this.data.invoiceAddress.companyName.length === 0 ||
                !this.data.invoiceAddress.taxNumber ||
                this.data.invoiceAddress.taxNumber && this.data.invoiceAddress.taxNumber.length === 0
            )
    }

    get isCompanyNameRequired() {
        return this.data.invoiceAddress.invoice === '1';
    }

    get isTaxNumberRequired() {
        return !(
            this.data.invoiceAddress.invoice === '0' ||
            this.shopId === 2||
            this.shopId === 5 && this.taxIdOmit === true ||
            this.shopId === 4 && this.data.invoiceAddress.country === 'CZ' && this.summary.gros_value_of_products_with_discount + this.summary.gros_value_of_shipment < 10000
        );
    }

    get isUserDataFormValid() {
        if (this.userLogged) {
            return !!this.data.invoiceAddressId;
        } else {
            if (!this.userDataForm) {
                return false;
            }

            return this.userDataForm.$valid;
        }
    }

    get isDropshippingAvailable() {
        const invoiceAddress = this.getAddressById(this.data.invoiceAddressId);
        if (invoiceAddress !== null && invoiceAddress.is_company && this.confirmation.shipment.transport_type === 'gls' && this.shopId === 1) {
            return true;
        }

        return false;
    }

    get stepThreeComplete() {
        return this.summary.payment_id && this.summary.shipment_id && this.items;
    }

    get orderFinalized() {
        if (this.orderId) return true;

        return false;
    }

    currencySymbol() {
        if (!this.summary.currency.symbol) {
            return '';
        }

        return this.summary.currency.symbol;
    }
}

export default CheckoutService;
